import _slicedToArray from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["children"];
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// ignore-string-externalization
import React from 'react';
import qs from 'query-string';
import { marked } from 'marked';
import getCookies from 'next-cookies';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export var youtubeIdRegex = /^https:\/\/(?:www\.youtube\.com\/watch\?v=|youtu\.be\/)([^/&\s]+)/i;
export function apiCall(_x) {
  return _apiCall.apply(this, arguments);
}

function _apiCall() {
  _apiCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var qparams,
        baseUrl,
        fetchUrl,
        resp,
        data,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            qparams = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            baseUrl = true ? '' : process.env.REACT_APP_API_BASE_URL;
            fetchUrl = "".concat(baseUrl, "/api/").concat(url, "?").concat(qs.stringify(qparams));
            _context.next = 5;
            return fetch(fetchUrl);

          case 5:
            resp = _context.sent;
            _context.next = 8;
            return resp.json();

          case 8:
            data = _context.sent;
            return _context.abrupt("return", data);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _apiCall.apply(this, arguments);
}

export var withoutProps = function withoutProps(Component) {
  for (var _len = arguments.length, excludeProps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    excludeProps[_key - 1] = arguments[_key];
  }

  return function (props) {
    var children = props.children,
        compProps = _objectWithoutProperties(props, _excluded);

    var _iterator = _createForOfIteratorHelper(excludeProps),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        delete compProps[prop];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, compProps), {}, {
      children: children
    }));
  };
};
export function useScrollYPosition() {
  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      y = _React$useState2[0],
      setY = _React$useState2[1];

  useScrollPosition(function (_ref) {
    var currPos = _ref.currPos;
    setY(currPos.y);
  }, []);
  return y;
} // super-simple markdown formatter, mostly just line breaks, bold and italics

export function formatText(str) {
  return marked.parseInline((str || '').trim().replace(/(\\n|\n)/g, '<br />'), {
    xhtml: true,
    smartypants: true
  });
} // fix common mistakes in href's entered from contentful

export function fixHref(val) {
  if (val === null || val === undefined) {
    return val;
  }

  var href = val.trim().replace(/^((https|http):)?(\/\/)?artists\.spotify\.com/, '');
  if (href === '') href = '/'; // empty url probably refers to root, esp after ^^^

  return href;
}
export var getTallest = function getTallest(refCollection) {
  var tallestRef = 0;
  refCollection.forEach(function (ref) {
    if (ref.current) {
      ref.current.classList.remove('tallest');
      var thisRefHeight = ref.current.getBoundingClientRect().height;

      if (thisRefHeight > tallestRef) {
        tallestRef = thisRefHeight;
      }
    }
  });
  return tallestRef;
};
export var setTallestClass = function setTallestClass(refCollection) {
  refCollection.forEach(function (ref) {
    if (ref.current) {
      ref.current.classList.add('tallest');
    }
  });
};
export function isPreview(context) {
  var cookies = getCookies(context);
  return Boolean(cookies.__prerender_bypass && cookies.__next_preview_data);
}
export var getAuthorDateString = function getAuthorDateString(author, releaseDate) {
  if (author && releaseDate && releaseDate !== 'Invalid Date') {
    return "".concat(author, " / ").concat(releaseDate);
  } else if (author) {
    return author;
  } else if (releaseDate !== 'Invalid Date') {
    return releaseDate;
  }

  return '';
};
export var transformScaleUp = "transform: scale(1.05);";
export function isContentfulImage(url) {
  return url && (url.includes('images.ctfassets.net') || url.includes('images.contentful.com'));
}
export var isValidPath = function isValidPath(url) {
  if (url) {
    var decoded = decodeURIComponent(url);
    return !decoded.includes('\\') && !decoded.match(/^\/\//) && !decoded.match(/^.+:.+/);
  }

  return false;
};
export var getBurst = function getBurst(color) {
  return css(["background-image:url(\" data:image/svg+xml,%3Csvg width='465' height='225' viewBox='0 0 465 224' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 223L332.118 2L250.776 207.016L353.662 123.272L336.101 184.082L465 106.069' stroke='%23", "'/%3E%3C/svg%3E \");background-size:contain;background-repeat:no-repeat;background-position:right center;"], color.substring(1));
};